<template>
<div class="swaychat-row swaychat-faux" @click="toggle" :class="{
    'swaychat-receipt-off': !tail && !showTail
    }">
  <div class="swaychat-bubble-wrapper swaychat-bounceIn" :class="{
      'swaychat-operator': operator,
      'swaychat-visitor': !operator
      }">
    <div class="swaychat-bubble" :style="{
        'background-color': !operator ? getPrimaryBg : ''
        }">
      <p v-if="media" class="swaychat-bubble-media">
        <b :style="{
        'height': media.type == 'audio' ? '30px' : ''
        }"></b>
      </p>
      <p v-else>
        <i v-for="n in msgLength"></i>
      </p>
    </div>
    <span class="swaychat-tail" :style="{
        'background-color': !operator ? getPrimaryBg : ''
        }"> </span>
  </div>
  <div class="swaychat-row swaychat-read-receipt" :class="{
      'swaychat-operator': operator,
      'swaychat-visitor': !operator
      }">
    <span>
      <i></i><i></i><i></i>
      <i></i><i></i><i></i><i></i><i></i>
      <i></i><i></i>
    </span>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import moment from 'moment'

export default {
  props: [
    'operator',
    'tail',
    'msgLength',
    'created_at',
    'media',
    'from',
    'read'
  ],
  data() {
    return {
      showTail: false
    }
  },
  computed: {
    ...mapGetters([
      'getPrimaryBg'
    ])
  },
  methods: {
    toggle() {
      this.showTail = !this.showTail
    }
  }
}
</script>
